<template>
  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
    <isis-tabs @on-tab-change="onTabChanged" :key="index">
      <template #content>
        <md-tab
          :id="tabs.email"
          md-label="communication.send_email"
          v-if="$can(Communication.actions.sendMail, Communication.subject)"
        >
          <send-email
            @update-form-data="resetFormData"
            :userRole="userRole"
            :ref="tabs.email"
            :form-data="formSendEmail"
          ></send-email>
        </md-tab>
        <md-tab
          :id="tabs.announcement"
          md-label="communication.send_announcement"
          v-if="
            $can(Communication.actions.sendAnnouncement, Communication.subject)
          "
        >
          <send-announcement
            :userRole="userRole"
            @update-form-data="resetFormData"
            :ref="tabs.announcement"
            :form-data="formSendAnnouncement"
          ></send-announcement>
        </md-tab>
        <md-tab
          :id="tabs.sms"
          md-label="communication.send_sms"
          v-if="$can(Communication.actions.sendSms, Communication.subject)"
        >
          <send-sms
            :ref="tabs.sms"
            @send-sms="sendSms($event)"
            @detail-sms="detailSms"
          ></send-sms>
        </md-tab>
        <md-tab
          v-if="
            $can(Communication.actions.template, Communication.subject) ||
              $can(All.actions, All.subject)
          "
          :id="tabs.template"
          md-label="communication.manage_template"
          class="template-tab"
        >
          <template-manage
            @edit-template="editTemplate($event)"
            :ref="tabs.template"
            @async-template="asyncTemplate($event)"
          ></template-manage>
        </md-tab>
      </template>
    </isis-tabs>

    <!--    MODAL MANAGE TEMPLATE-->
    <common-modal
      :name="currentTemplateName"
      :height="'auto'"
      :width="'70%'"
      :title="setCurrentTemplateTitle()"
      :primaryAction="primaryAction"
      :secondaryActions="secondaryActions"
    >
      <template #modal-body>
        <validation-form @on-submit="doSubmit" ref="templateFormRef">
          <template-form
            :currentTemplate="currentTemplate"
            :server-validations="serverValidations"
            :template-validation="templateValidation"
          ></template-form>
        </validation-form>
      </template>
    </common-modal>
    <!-- send-sms -->
    <div class="sms">
      <common-modal
        height="auto"
        width="70%"
        :primaryAction="sendSmsAction"
        :secondaryActions="cancelActions"
        :name="currentSms.name"
        title="communication.send_sms"
      >
        <template #modal-body>
          <validation-form @on-submit="doSubmitSms" ref="smsFormRef">
            <send-sms-form
              :template-validation="templateValidation"
              ref="smsChildRef"
              @sendSuccess="sendSuccess"
            ></send-sms-form>
          </validation-form>
        </template>
      </common-modal>
    </div>
    <!-- detail-sms -->
    <div class="detail-sms">
      <common-modal
        height="auto"
        width="70%"
        :primaryAction="reSendSmsAction"
        :secondaryActions="exitDetail"
        :name="detailResendSms.name"
        :title="titleSmsDetail"
      >
        <template #modal-body>
          <validation-form>
            <detail-sms-form
              @hook:mounted="getDetailSms"
              @disableReSend="disableReSend"
              ref="smsDetailRef"
            ></detail-sms-form>
          </validation-form>
        </template>
      </common-modal>
    </div>
  </div>
</template>

<script>
import IsisTabs from "@/components/Base/IsisTabs";
import SendEmail from "./SendEmail";
import SendSms from "./SendSms/ListPage";
import { Communication, All } from "@/constants/Permissions";
import { Message } from "@/helpers/utils";
import { validations } from "@/validations/communication";
import TemplateForm from "./../Tabs/Template/templateForm";
import SendAnnouncement from "./SendAnnouncement";
import { genErrMsgOj } from "@/helpers/utils";
import { service_paths, service_names } from "@/constants/Services";
import CommonModal from "@/components/Base/CommonModal.vue";
import TemplateManage from "./Template";
import { mapGetters } from "vuex";
import { getId } from "@/helpers/utils";
import SendSmsForm from "./SendSms/sendSmsForm.vue";
import detailSmsForm from "./SendSms/detailSmsForm.vue";

const defaultFormData = () => ({
  template: "",
  allow_student_counselor: false,
  allow_student_family: false,
  attachments: [{ name: "" }],
  recipients: "",
  title: "",
  filter_by: "",
  selectedList: [],
  classes: [],
  grades: [],
  counselors: [],
  staffs: [],
  terms: [],
  programs: [],
  students: [],
  contents: "",
  role_id: null,
  variables: []
});
export default {
  name: "communication-tabs",
  components: {
    SendAnnouncement,
    IsisTabs,
    SendEmail,
    TemplateForm,
    CommonModal,
    TemplateManage,
    SendSms,
    SendSmsForm,
    detailSmsForm
  },
  data() {
    return {
      Communication,
      All,
      tabs: {
        email: "tab-send-email",
        template: "tab-manage-template",
        announcement: "tab-send-announcement",
        sms: "tab-send-sms"
      },
      templateValidation: validations,
      serverValidations: {},
      currentTemplate: {},
      form: {
        templateName: ""
      },
      formSendEmail: defaultFormData(),
      formSendAnnouncement: defaultFormData(),
      index: 0,
      tabsWithoutFooter: ["tab-manage-template"],
      currentTemplateName: "communication-template",
      curTab: null,
      primaryAction: {
        title: "common.add_new",
        action: this.subMitTemplate
      },
      secondaryActions: [
        {
          title: "common.cancel",
          action: () => {
            this.$modal.hide(this.currentTemplateName);
          }
        }
      ],
      // data sms
      currentSms: {
        name: "currentSms"
      },
      sendSmsAction: {
        title: "communication.send",
        action: this.submitSms
      },
      cancelActions: [
        {
          title: "common.cancel",
          action: () => {
            this.$modal.hide(this.currentSms.name);
          }
        }
      ],
      // detail sms
      smsId: null,
      titleSmsDetail: null,
      detailResendSms: {
        name: "detailSms"
      },
      reSendSmsAction: {
        title: "communication.resend",
        action: this.reSendSms,
        disabled: true
      },
      exitDetail: [
        {
          title: "common.cancel",
          action: () => {
            this.$modal.hide(this.detailResendSms.name);
          }
        }
      ]
    };
  },
  created() {
    this.onTabChanged(this.tabs.email);
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    })
  },
  methods: {
    // detail sms
    detailSms(item) {
      this.smsId = getId(item);
      this.$nextTick(() => {
        this.$modal.show(this.detailResendSms.name);
      });
    },
    async getDetailSms() {
      await this.$refs.smsDetailRef.getDetailSms(this.smsId);
      this.titleSmsDetail = `${this.$t("communication.sms_detail")} : ${
        this.$refs.smsDetailRef.general_information.title
      }`;
    },
    async reSendSms() {
      await this.$refs.smsDetailRef.reSendSms();
      this.$modal.hide(this.detailResendSms.name);
    },
    disableReSend(condition) {
      this.reSendSmsAction.disabled = condition;
    },
    // sms
    sendSms(e) {
      this.$nextTick(() => {
        this.$modal.show(this.currentSms.name);
      });
    },
    submitSms() {
      this.$refs.smsFormRef.submitForm();
    },
    doSubmitSms() {
      this.$refs.smsChildRef.validateRecipient();
    },
    sendSuccess() {
      this.$nextTick(() => {
        this.$modal.hide(this.currentSms.name);
      });
      this.$refs[this.tabs.sms].fetchDataTable();
    },
    // template
    setCurrentTemplateTitle() {
      return getId(this.currentTemplate)
        ? "communication.template_detail"
        : "communication.add_new_template";
    },
    editTemplate(e) {
      this.currentTemplate = e;
      this.primaryAction.title = !!e._id ? "common.save" : "common.add_new";
      this.serverValidations = {};
      this.$nextTick(() => {
        this.$modal.show(this.currentTemplateName);
      });
    },
    subMitTemplate() {
      this.$refs.templateFormRef.submitForm();
    },
    doSubmit() {
      this.currentTemplate.variables = this.currentTemplate.variables.filter(
        variable => variable.key
      );
      this.saveTemplate();
    },
    saveTemplate() {
      let templateData = this.currentTemplate;
      if (this.currentTemplate.attachments) {
        templateData.attachments[0].name = this.currentTemplate.attachments[0].name.replace(
          "-",
          "_"
        );
      }
      const errMsg = this.$t("common.form_invalid");
      if (this.currentTemplate._id) {
        this.$axios
          .put(
            `${service_paths.communication_template}/${templateData._id}`,
            templateData,
            true,
            {},
            errMsg
          )
          .then(() => {
            this.$modal.hide(this.currentTemplateName);
            this.$refs[this.tabs.template].fetchDataTable();
            this.$refs[this.tabs.template].resetTemplateForm();
            this.$nextTick(() => {
              const message = this.$t(
                "communication.communication_template_successfully_edited"
              );
              Message.success(message);
              this.asyncTemplate(templateData);
            });
          })
          .catch(error => {
            const errData = error.response?.data;
            if (errData) {
              const svErrMsgs = errData.messages;
              this.serverValidations = genErrMsgOj(svErrMsgs);
            }
          });
      } else {
        this.$axios
          .post(
            `${service_paths.communication_template}`,
            templateData,
            true,
            {},
            errMsg
          )
          .then(() => {
            this.$modal.hide(this.currentTemplateName);
            this.$refs[this.tabs.template].fetchDataTable();
            this.$refs[this.tabs.template].resetTemplateForm();
            this.$nextTick(() => {
              const message = this.$t(
                "communication.add_new_communication_template_successfully"
              );
              Message.success(message);
              this.asyncTemplate(templateData);
            });
          })
          .catch(error => {
            const errData = error.response?.data;
            if (errData) {
              const svErrMsgs = errData.messages;
              this.serverValidations = genErrMsgOj(svErrMsgs);
            }
          });
      }
    },
    onTabChanged(tabId) {
      const hasFooterActions = !this.tabsWithoutFooter.includes(tabId);
      this.curTab = this.$refs[tabId];
      this.$emit("update-check-footer", hasFooterActions);
    },
    asyncTemplate(template) {
      if (template.type === "email") {
        this.$refs[this.tabs.email].getTemplates();
      }
      if (template.type === "announcement") {
        this.$refs[this.tabs.announcement].getTemplates();
      }
    },
    submit() {
      this.curTab.sendNotifications();
    },
    resetFormData(type) {
      if (type === "email") {
        this.formSendEmail = defaultFormData();
      }
      if (type === "announcement") {
        this.formSendAnnouncement = defaultFormData();
      }
      this.index++;
    }
  }
};
</script>

<style lang="scss">
.tox-statusbar__branding {
  display: none;
}
.template-tab > div > .md-layout > .md-layout-item {
  padding: 0;
}
.sms .isis-modal-footer {
  justify-content: center;
}
</style>
